import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "../../../styles/__login.module.scss";
import Footer from "../../../components/footer/Footer";
import { useDispatch } from "react-redux";
import { postResetPassword } from "../../../reducer/resetPassword/resetPasswordReducer";
import { useLocation } from "react-router-dom"; // ✅ Get reset token from URL params
import { ChevronDown } from "lucide-react";
import india from "../../../assets/images/flags/Flag_of_India-64x43.png";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [showPasswordNew, setShowPasswordNew] = useState(false);
  const [showPasswordCon, setShowPasswordCon] = useState(false);
  const [showPasswordCurrent, setShowPasswordCurrent] = useState(false);
  const token = queryParams.get("token");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  console.log("token:", token);
  const [selectedCountry, setSelectedCountry] = useState("+964");
  const [mobileNumber, setMobileNumber] = useState("");

  const countries = [
    { code: "+964", flag: "/flags/Flag_of_Iraq-64x43.png", name: "Iraq" },
    { code: "+91", flag: india, name: "India" },
    { code: "+20", flag: "/flags/Flag_of_Egypt-64x43.png", name: "Egypt" },
    {
      code: "+1",
      flag: "/flags/Flag_of_United_States-64x34.png",
      name: "United States",
    },
  ];
  const selectedCountryData =
    countries.find((country) => country.code === selectedCountry) ||
    countries[0];

  // ✅ Password rules
  const passwordRules = {
    length: {
      test: (pwd) => pwd.length >= 8,
      message: "At least 8 characters",
    },
    lowercase: {
      test: (pwd) => /[a-z]/.test(pwd),
      message: "At least one lowercase letter",
    },
    uppercase: {
      test: (pwd) => /[A-Z]/.test(pwd),
      message: "At least one uppercase letter",
    },
    number: {
      test: (pwd) => /[0-9]/.test(pwd),
      message: "At least one number",
    },
    special: {
      test: (pwd) => /[!@#$%^&*(),.?\":{}|<>]/.test(pwd),
      message: "At least one special character",
    },
  };

  // ✅ Validation function
  const validateForm = () => {
    const newErrors = {};

    // New password validation
    if (!password.trim()) {
      newErrors.password = "New password is required";
    } else {
      const failedRule = Object.values(passwordRules).find(
        (rule) => !rule.test(password),
      );
      if (failedRule) newErrors.password = failedRule.message;
    }

    // Confirm password validation
    if (!confirmPassword.trim()) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ Handle Submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      new_password: password,
      confirm_password: confirmPassword,
      reset_token: token, // ✅ Now included from params
    };
    dispatch(postResetPassword(payload));

    console.log("Reset Password Data:", payload);

    // API call can go here using Redux or fetch
    // navigate("/"); // Redirect after success
  };

  return (
    <div className={styles["main-container"]}>
      <main className={styles["main-content"]}>
        <div className={styles["content-wrapper"]}>
          {/* Illustration */}
          <div className={styles["illustration"]}>
            <div className={styles["doctor-illustration"]}>
              <img
                src="/ForgotPassword.png"
                alt="Doctor illustration"
                className={styles["doctor-image"]}
              />
            </div>
          </div>

          {/* Reset Password Form */}
          <div className={styles["login-form-container"]}>
            <h2>{t("forgotPassword") || "Forgot Password"}</h2>

            <form onSubmit={handleSubmit} className={styles["login-form"]}>
              {/* Username */}
              {/* <div className={styles["form-group"]}>
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  id="username"
                  placeholder="Enter your username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className={styles["form-input"]}
                />
                {errors?.username && (
                  <p className={styles["rule-invalid"]}>{errors?.username || "error invalid"}</p>
                )}
              </div> */}

              {/* Mobile Number */}
              <div className={styles["form-group"]}>
                <label htmlFor="mobile">Mobile Number</label>
                <div className={styles["mobile-input-container"]}>
                  <div className={styles["country-selector"]}>
                    <span className={styles["selected-flag"]}>
                      <img src={selectedCountryData?.flag} alt="" />
                      <span className={styles["selected-countryCode"]}>
                        {selectedCountryData.code}
                      </span>
                    </span>

                    <select
                      value={selectedCountry}
                      onChange={(e) => setSelectedCountry(e.target.value)}
                      className={styles["country-dropdown"]}
                    >
                      {countries.map((country) => (
                        <option key={country?.code} value={country?.code}>
                          {country?.code} {country?.name}
                        </option>
                      ))}
                    </select>
                    <ChevronDown
                      size={14}
                      className={styles["dropdown-arrow"]}
                    />
                  </div>
                  <input
                    type="tel"
                    id="mobile"
                    placeholder="770 123 4567"
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    className={styles["phone-input"]}
                  />
                </div>
                {errors?.mobileNumber && (
                  <p className={styles["rule-invalid"]}>
                    {errors?.mobileNumber}
                  </p>
                )}
              </div>

              {/* New Password */}
              <div className={styles["form-group"]}>
                <label htmlFor="password">{t("newPassword")}</label>
                <div className={styles["password-wrapper"]}>
                  <input
                    type={showPasswordNew ? "text" : "password"}
                    id="password"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={styles["form-input"]}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPasswordNew(!showPasswordNew)}
                    className={styles["password-toggle"]}
                  >
                    {!showPasswordNew ? (
                      <EyeOff size={20} />
                    ) : (
                      <Eye size={20} />
                    )}
                  </button>
                </div>

                {/* Password rule indicators */}
                {/* <div className={styles["password-rules"]}>
                  {Object.keys(passwordRules).map((ruleKey) => {
                    const rule = passwordRules[ruleKey];
                    const isValid = rule.test(password);
                    return (
                      <p
                        key={ruleKey}
                        className={isValid ? styles["rule-valid"] : styles["rule-invalid"]}
                      >
                        {isValid ? "✔" : "✖"} {rule.message}
                      </p>
                    );
                  })}
                </div> */}

                {errors.password && (
                  <p className={styles["rule-invalid"]}>{errors.password}</p>
                )}
              </div>

              {/* Confirm Password */}
              <div className={styles["form-group"]}>
                <label htmlFor="confirmPassword">{t("confirmPassword")}</label>
                <div className={styles["password-wrapper"]}>
                  <input
                    type={showPasswordCon ? "text" : "password"}
                    id="confirmPassword"
                    placeholder="••••••••"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className={styles["form-input"]}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPasswordCon(!showPasswordCon)}
                    className={styles["password-toggle"]}
                  >
                    {!showPasswordCon ? (
                      <EyeOff size={20} />
                    ) : (
                      <Eye size={20} />
                    )}
                  </button>
                </div>
                {errors.confirmPassword && (
                  <p className={styles["rule-invalid"]}>
                    {errors.confirmPassword}
                  </p>
                )}
              </div>

              {/* Submit Button */}
              <button type="submit" className={styles["login-btn"]}>
                {t("resetPassword")}
              </button>
            </form>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ForgotPassword;
